import type { Airflow } from '@aviata/platform-types';
import { isAncillary } from '../types/guards';

export const getBaggagePrice = (
  productsList: Airflow.Order.Entity['products'],
) => {
  const baggage = productsList.filter(
    product =>
      isAncillary(product) && product.type === 'airflow.ancillary.baggage',
  );
  if (baggage.length !== 0) {
    return baggage.reduce((price, baggage) => {
      return price + Number(baggage.total);
    }, 0);
  }
  return null;
};
